import { useState, useCallback } from 'react';

export default function useAudioDevices() {
  const [inputDevices, setInputDevices] = useState([]);
  const [outputDevices, setOutputDevices] = useState([]);
  const [selectedInputId, setSelectedInputId] = useState(null);
  const [selectedOutputId, setSelectedOutputId] = useState(null);

  const fetchDevices = useCallback(async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const mics = devices.filter(d => d.kind === 'audioinput');
      const speakers = devices.filter(d => d.kind === 'audiooutput');

      setInputDevices(mics);
      setOutputDevices(speakers);

      if (!selectedInputId && mics.length > 0) {
        setSelectedInputId(mics[0].deviceId);
      }

      if (!selectedOutputId && speakers.length > 0) {
        setSelectedOutputId(speakers[0].deviceId);
      }
    } catch (err) {
      console.warn('[Audio Device] Error fetching devices:', err);
    }
  }, [selectedInputId, selectedOutputId]);

  return {
    inputDevices,
    outputDevices,
    selectedInputId,
    setSelectedInputId,
    selectedOutputId,
    setSelectedOutputId,
    fetchDevices,
  };
}